// Module
var code = `<div data-slot="pagination-items"></div>
`;
// Exports
module.exports = code;